import React from 'react';
import { Dialog as DialogUI } from 'xland-ui';
import { useSelector } from 'react-redux';
import useDialog from './useDialog';
import DialogContent from './DialogContent';
import DialogActions from './DialogActions';

function DialogModal() {
  const literals = useSelector(state => state.i18n.literals.dialog);
  const {
    show, title, type, text, actions,
  } = useSelector(state => state.global.dialog);
  const { onClick } = useDialog();

  return show && (
    <DialogUI
      open
      title={title}
      onClose={() => onClick(false)}
      actions={(
        <DialogActions
          literals={literals}
          type={type}
          actions={actions}
          onClick={onClick}
        />
      )}
    >
      <DialogContent loading={type === 'loading'} text={text} />
    </DialogUI>
  );
}

export default DialogModal;
